import { Theme, alpha } from '@mui/material';

export const getPrimaryWithAlpha = (value: number) => (theme: Theme) =>
  alpha(theme.palette.primary.main, value);
